import React from 'react';
import { MdVpnKey, MdOpenInNew } from 'react-icons/md';
import { useOrganizationCredentials } from './hooks';
import DefaultButton from '../ReusableComponents/DefaultButton';
import StatusBadge from '../ReusableComponents/StatusBadge';
import PortalConfiguration from '../PortalAluno/components/PortalConfiguration';
import { ErrorNotice } from '../PortalAluno/components/Feedback';
export default function Integrations({ organization: o }) {
  const credentials = useOrganizationCredentials();
  return (
    <>
      <section className="card module-card module-content">
        <div className="card-body">
          <div className="module-content-heading hidethis">
            <h2>Integrações</h2>
            <p>Credenciais da API e serviços disponíveis para a organizadora.</p>
          </div>
          <div className="portal-admin-row">
            <div>
              <h3>API da OnTest</h3>
              <p>Consulte as credenciais para integrar seus serviços à OnTest.</p>
            </div>
            {o.can_edit && (
              <DefaultButton
                text={credentials.data ? 'Ocultar credenciais' : 'Exibir credenciais'}
                bg="warning"
                icon={<MdVpnKey />}
                loading={credentials.isLoading}
                onClick={() => (credentials.data ? credentials.reset() : credentials.mutate())}
              />
            )}
          </div>
          <ErrorNotice error={credentials.error} />
          {credentials.data && (
            <dl className="portal-admin-facts hidethis">
              <div>
                <dt>API Key</dt>
                <dd>{credentials.data.api_key}</dd>
              </div>
              <div>
                <dt>API Secret</dt>
                <dd>{credentials.data.api_secret}</dd>
              </div>
            </dl>
          )}
          <a
            className="portal-external-link hidethis"
            href="https://docs.google.com/document/d/1Q4U8rm0f6G1ya0c21Y6VZSQZf7uOKJuX/edit"
            target="_blank"
            rel="noopener noreferrer"
          >
            <MdOpenInNew /> Documentação da API
          </a>
        </div>
      </section>
      <section className="card module-card module-content">
        <div className="card-body">
          <div className="portal-admin-row">
            <div className="module-content-heading hidethis">
              <h2>Portal de inscrições</h2>
              <p>Inscrições, documentos e acompanhamento dos candidatos.</p>
            </div>
            <StatusBadge variant={o.portal_enabled ? 'success' : 'secondary'}>
              {o.portal_enabled ? 'Habilitado' : 'Desabilitado'}
            </StatusBadge>
          </div>
          <div className="portal-admin-actions hidethis">
            {o.portal_enabled && (
              <DefaultButton
                text="Gerenciar inscrições"
                bg="info"
                to={`/instituicao/portal/${o.id}`}
              />
            )}
            {o.portal_enabled && o.integrations?.portal_frontend_url && (
              <a
                className="btn btn-success portal-external-link"
                href={o.integrations.portal_frontend_url}
                target="_blank"
                rel="noopener noreferrer"
              >
                Acessar portal <MdOpenInNew />
              </a>
            )}
          </div>
          {!o.portal_enabled && (
            <p className="text-muted mb-0">
              O portal de inscrições está desabilitado para esta organizadora.
            </p>
          )}
        </div>
      </section>
      <PortalConfiguration organizationId={o.id} />
    </>
  );
}
